<template>
  <!-- eslint-disable-next-line local-rules/external-attribute -->
  <input class="hidden-input" v-bind="$attrs" tabindex="-1" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HiddenInput',
});
</script>

<style lang="scss" scoped>
.hidden-input {
  opacity: 0;
  position: absolute;
  width: 0;
  border: 0;
  height: 0;
  margin: 0;
  padding: 0;
  pointer-events: none;
}
</style>
